import { GlobalData } from "../Common/GlobalData";
import { ReportDateHelper, TemplateHelpers } from "../Common/KendoHelpers";
import { StockPickList } from "../Common/StockPickList";

export class MovingAverageCrossoverDaily {
    private static readonly GRID = '#grid';

    constructor() {
        this.init();
    }

    private init() {
        const stockPickList = new StockPickList(MovingAverageCrossoverDaily.GRID,
            GlobalData.URL_SUFFIX_TECHNICAL_REPORTS_MOVING_AVERAGE_CROSSOVER_DAILY);

        $(MovingAverageCrossoverDaily.GRID).kendoGrid({
            dataSource: new kendo.data.DataSource(stockPickList.getDataSourceOptions()),
            height: 915,
            groupable: false,
            sortable: true,
            pageable: false,
            dataBound: () => {
                const data = $(MovingAverageCrossoverDaily.GRID).data('kendoGrid')!.dataSource.data();
                if (!data || data.length == 0) {
                    return;
                }

                ReportDateHelper.showReportDate(data[0].closingDate);
            },
            columns: [{
                field: 'symbol',
                title: 'Symbol',
                width: '5%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'companyName',
                title: 'Company Name',
                width: '19%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12-left' },
                attributes: { 'class': 'table-cell grid-cell-left' },
            }, {
                field: 'close',
                title: 'Close',
                width: '6%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'candlestick',
                title: 'Candlestick',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                sortable: false,
                template: kendo.template(TemplateHelpers.getCandlestick('../images', 'closePosition', 'closeUpFromYesterday')),
            }, {
                field: 'fiftyDaySma',
                title: 'SMA(50)<br>Value',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'smA50Slope',
                title: 'SMA(50)<br>Slope',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'crossover',
                title: 'SMA(50)<br>Crossover',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:p1}',
            }, {
                field: 'currDaysVolGtPrevTenDays',
                title: 'Vol<br>GT10<br>Days',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getGreenBoolTemplate('currDaysVolGtPrevTenDays')),
            }, {
                field: 'earningsPerShareDueDate',
                title: 'Earnings<br>Due Date',
                width: '7%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('earningsPerShareDueDate')),
            }]
        });
    }

    private getTooltipRow(name: string, value: string) {
        return '<tr class="mah-tooltip-tr"><td class="mah-tooltip-td-left">' +
            name + '</td><td class="mah-tooltip-td-right">' +
            value + '</td></tr>';
    }
}
